import React from "react";
import { useFormik } from "formik";
import CustomInput from "../formik/CustomInput.tsx";
import {
  parseAppointmentMinutes,
  updateAppoinmentTime,
} from "../../services/configuration.service.ts";
import { notification } from "../../utils/Notifications.tsx";
import { IModalEditTimeAppoinment } from "../../interfaces/others/IModalEditTimeAppoinment.ts";
import { EditTimeAppoinmentSchema } from "../../validation/schemas/EditTimeAppoinmentSchema.ts";

const EditTimeAppoinment: React.FC<IModalEditTimeAppoinment> = ({
  currentTime,
  setLoading,
  closeFn,
  refreshFn,
  onUpdated,
}) => {
  const formik = useFormik({
    initialValues: {
      time: currentTime,
    },
    enableReinitialize: true,
    validationSchema: EditTimeAppoinmentSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const saved = await updateAppoinmentTime(Number(values.time));
        const minutes = parseAppointmentMinutes(saved, Number(values.time));
        onUpdated?.(minutes);
        notification(
          "Éxito",
          `Tiempo por cita actualizado a ${minutes} minutos`,
          "success"
        );
        refreshFn();
        closeFn();
      } catch (error) {
        notification(
          "error",
          "Error al actualizar el tiempo de la cita",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <React.Fragment>
      <CustomInput
        formik={formik}
        field="time"
        label="Tiempo por cita"
        placeholder="Escribe el tiempo por cita"
        type="number"
        sm={8}
        smLabel={4}
      />
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-azul" onClick={() => formik.handleSubmit()}>
          Actualizar
        </button>
      </div>
    </React.Fragment>
  );
};

export default EditTimeAppoinment;
